module.exports = __webpack_public_path__ + "img/tab_01.c10689a9.jpg";